module.exports = {"ok":"Ok","cancel":"Cancel","back":"Back","edit":"Edit","submit":"Submit","confirm":"Confirm","yes":"YES","no":"NO","done":"Done","AdvancedSearch":"Advanced Search","Update":"Update","Print":"Print","Enabled":"Enabled","Disable":"Disable","View":"View","QRCode":"QR Code","Delete":"Delete","Search":"Search","Clear":"Clear","UserO365":"Import User o365","Add":"Add","Next":"Next","Unregister":"Unregister","O365Rooms":"{name} Rooms","importRoom":"Import Room","searchString":"Search Text","create":"Create","update":"Update","close":"Close","save":"Save"}


//////////////////
// WEBPACK FOOTER
// ./src/wording/pages/button/ENG.json
// module id = 1315
// module chunks = 120